/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

class ShortenerDetailDefault extends React.Component {
    render() {
        let panelContent = null,
            constants = this.props.app.config.constants,
            defaultToggle = false;

        if (parseInt(this.props.user.detail.defaultPdId, 10) === 1 && this.props.data.id === 1) {
            defaultToggle = true;
        } else if ((parseInt(this.props.user.detail.defaultSaId, 10) === 0 && this.props.data.id === 0) &&
                    parseInt(this.props.user.detail.defaultPdId, 10) === 0) {
            defaultToggle = true;
        } else if (parseInt(this.props.data.default, 10) === 1) {
            defaultToggle = true;
        }

        return (
            <div className="editor-panel">
                <fieldset>
                    <legend>Default</legend>
                    <Toggle
                        active={defaultToggle}
                        callback={this.props.updateSystemDefault}
                        linkedField="data.default"
                        activeLabel="Use this as the default when sharing manually or setting up new automated sharing."
                        inactiveLabel="Use this as the default when sharing manually or setting up new automated sharing."
                        labelPlacement="right"
                        labelClass="form-inline-label light" />
                </fieldset>
                {this.props.getApplyButtons()}
            </div>
        );
    }

};

export default ShortenerDetailDefault;
